import { render, staticRenderFns } from "./EditEmailConfig.vue?vue&type=template&id=1c739712&"
import script from "./EditEmailConfig.vue?vue&type=script&lang=js&"
export * from "./EditEmailConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports